// src/lib/redux/executionHistories/executionHistoriesSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ExecutionHistory } from "@/lib/redux/context";

interface ExecutionHistoriesState {
  data: ExecutionHistory[] | null;
  loading: boolean;
  error: string | null;
  meta: {
    total_items: number;
    total_pages: number;
    current_page: number;
    per_page: number;
    has_next: boolean;
    has_prev: boolean;
  } | null;
  links: {
    first: string | null;
    prev: string | null;
    next: string | null;
    last: string | null;
  } | null;
}

const initialState: ExecutionHistoriesState = {
  data: null,
  loading: false,
  error: null,
  meta: null,
  links: null,
};

const executionHistoriesSlice = createSlice({
  name: "executionHistories",
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
      if (action.payload) state.error = null;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
    setExecutionHistories(
      state,
      action: PayloadAction<{
        items: ExecutionHistory[];
        meta: ExecutionHistoriesState["meta"];
        links: ExecutionHistoriesState["links"];
      }>
    ) {
      state.data = action.payload.items;
      state.meta = action.payload.meta;
      state.links = action.payload.links;
      state.loading = false;
      state.error = null;
    },
    fetchExecutionHistoriesStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchExecutionHistoriesSuccess(
      state,
      action: PayloadAction<{
        items: ExecutionHistory[];
        meta: ExecutionHistoriesState["meta"];
        links: ExecutionHistoriesState["links"];
      }>
    ) {
      state.data = action.payload.items;
      state.meta = action.payload.meta;
      state.links = action.payload.links;
      state.loading = false;
      state.error = null;
    },
    fetchExecutionHistoriesFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  setLoading,
  setError,
  setExecutionHistories,
  fetchExecutionHistoriesStart,
  fetchExecutionHistoriesSuccess,
  fetchExecutionHistoriesFailure,
} = executionHistoriesSlice.actions;

export default executionHistoriesSlice.reducer;